<template>
  <div class="app-container">
    <div class="query">
      <div class="status">
        <div class="item color0" @click="changeState(0)">
          <div class="name" :class="{ active: active==0 }">生产中 ({{ typeData.onLineCount || 0 }})</div>
        </div>
        <div class="item color1" @click="changeState(1)">
          <div class="name" :class="{ active: active==1 }">待机中 ({{ typeData.waitCount || 0 }})</div>
        </div>
        <div class="item color2" @click="changeState(2)">
          <div class="name" :class="{ active: active==2 }">故障中 ({{ typeData.faultCount || 0 }})</div>
        </div>
        <div class="item color3" @click="changeState(3)">
          <div class="name" :class="{ active: active==3 }">关机中 ({{ typeData.offLineCount || 0 }})</div>
        </div>
      </div>
      <el-form inline label-width="0px" style="margin: 5px 0 0 40px;">
        <el-form-item>
          <el-input v-model="DeviceCode" placeholder="请输入设备编号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="device">
      <div class="item" v-for="(item,index) in data" :key="index" @click="showInfo(item)">
        <div class="blank" :class="'color' + active" />
        <div class="name">{{ item.EquipmentName }}({{ item.EquipmentNo }})</div>
        <div class="info">
          <div class="left">时间</div>
          <div class="right">{{ item.StartTime }}</div>
        </div>
        <div class="info">
          <div class="left">工单号</div>
          <div class="right">{{ item.WorkDocNo }}</div>
        </div>
        <div class="info">
          <div class="left">模具</div>
          <div class="right">{{ item.MouldNo }}</div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.PageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="params.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <edit-dialog ref="editDialog" />
  </div>
</template>
<script>
import editDialog from "@/components/demo/devicestate/editDialog";
import api from "@/api/ba/equipment";
export default {
  components: { editDialog },
  name: "devicestate",
  watch: {
    active(nv) {

    }
  },
  data() {
    return {
      active: 0,
      DeviceCode: "",
      data: [],
      total: 0,
      params: {
        PageIndex: 1,
        PageSize: 30,
        EquipmentNo: null,
        OperatingStatus: null,
        Statuses: [1, 2],
        isBottom: false,
        TotalPages: 0,
        EquipmentTypeId: 6
      },
      typeData: {
        faultCount: 0,
        offLineCount: 0,
        onLineCount: 0,
        waitCount: 0
      }
    }
  },
  beforeMount() {
    this.getTypesAndChgState(0);
  },
  methods: {
    getTypes() {
      api.getOperatingTypes({}).then(res => {
        this.typeData = res.Data;
      })
    },
    getTypesAndChgState(state) {
      api.getOperatingTypes({}).then(res => {
        this.typeData = res.Data;
        this.changeState(state);
      })
    },
    changeState(state) {
      this.active = state;
      this.params.PageIndex = 1;
      this.params.PageSize = 30;
      this.params.Statuses = [1, 2];
      
      if (state == 0) {
        this.params.OperatingStatus = 2;
      } else if (state == 1) {
        this.params.OperatingStatus = 1;
      } else if (state == 2) {
        this.params.Statuses = [7];
        this.params.OperatingStatus = null;
      } else if (state == 3) {
        this.params.OperatingStatus = 0;
      }
      this.params.isBottom = false;
      this.getData();
    },
    getData() {
      var param = this.params;
      api.getEquipmentList(param).then(res => {
        if (res.Data) {
          var equipments = res.Data;
          var totalPages = Math.ceil(res.Count / param.PageSize);
          this.params.TotalPages = totalPages;
          this.total = res.Count;

          this.data = equipments;
        }
      })
    },
    search() {
      this.params.EquipmentNo = this.DeviceCode;
      this.params.PageIndex = 1;
      this.params.PageSize = 30;
      var operatingStatus = 1;
      if (this.active == 0) {
        operatingStatus = 2;
      } else if (this.active == 1) {
        operatingStatus = 1;
      } else if (this.active == 2) {
        operatingStatus = 3;
      } else if (this.active == 3) {
        operatingStatus = 0;
      }
      this.params.OperatingStatus = operatingStatus;
      this.params.isBottom = false;
      this.getData();
    },
    handleCurrentChange(val) {
      this.params.PageIndex = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.params.PageSize = val;
      this.params.PageIndex = 1;
      this.getData();
    },
    showInfo(item) {
      this.$refs.editDialog.openEdit(item);
    },
  }
};
</script>
<style scoped lang="scss">
.query {
  border-bottom: 2px solid #eee;
  padding-bottom: 0 !important;
  display: flex;
  .status {
    .item {
      width: 120px;
      color: #fff;
      padding: 6px 12px 14px;
      display: inline-block;
      margin-right: 10px;
      margin-top: 12px;
      border-radius: 10px 10px 2px 2px;
      cursor: pointer;
      height: 38px;
      .name {
        text-align: center;
        margin: auto;
        padding: 3px;
      }
    }
  }
}
.device {
  padding: 0 10px 10px;
  display: flex;
  flex-wrap: wrap;
  .item {
    cursor: pointer;
    width: 250px;
    border: 2px solid #ccc;
    border-top: none;
    position: relative;
    padding-top: 8px;
    margin: 12px 12px 0 0;
    .blank {
      position: absolute;
      height: 8px;
      width: 250px;
      top: 0;
      left: -2px;
    }
    .name {
      width: 230px;
      margin: 10px auto 20px;
      background-color: #ddd;
      line-height: 40px;
      font-weight: bold;
      text-align: center;
    }
    .info {
      font-size: 14px;
      margin-bottom: 15px;
      padding: 0 20px;
      display: flex;
      .left {
        width: 65px;
      }
    }
  }
}
.pagination {
  padding: 20px;
  text-align: center;
}
.active {
  border-bottom: 2px solid #fff;
}
.color0 {
  background-color: #339999;
}

.color1 {
  background-color: #EC7C46;
}

.color2 {
  background-color: #D82727;
}

.color3 {
  background-color: #666666;
}
</style>